import { FloatingActionButton } from '@fullscreendigital/carrefour-dex-fe'
import { KeyboardArrowUp } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useCallback } from 'react'

const ScrollTopButton = () => {
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <Box
      role="presentation"
      // Place the button in the bottom right corner.
      sx={{
        position: 'fixed',
        bottom: 32,
        right: 32,
        zIndex: 1
      }}
    >
      <FloatingActionButton
        onClick={scrollToTop}
        color="primary"
        size="small"
        aria-label="Scroll back to top"
      >
        <KeyboardArrowUp fontSize="medium" />
      </FloatingActionButton>
    </Box>
  )
}

export default ScrollTopButton
